import axios from 'axios';
import { isMatchingEnabled, isVacanciesEnabled, isUserManagementEnabled, isTeamManagementEnabled, isFeatureEnabled, isWebsiteManagementEnabled } from 'helpers/featureFlags';
import { createContext, useContext, useEffect, useState } from 'react';
import { GET_FEATURE_FLAG } from 'services/api';
import { useAuth } from 'context/authContext';
import { featureFlagsList } from 'constants/featureFlags';

export let FeatureFlagContext = createContext({
	featureFlags: [],
	useFeauteFlag: () => {},
	matchingEnabled: false,
	vacanciesEnabled: false,
	userManagementEnabled: false,
	teamManagementEnabled: false,
	websiteManagementEnabled: false,
	subscriptionEnabled: false,
	subscriptionTokenEnabled: false,
	termsAgreementEnabled: false,
	loading: true,
});

function FeatureFlagProvider({ children }) {
	const { isAuthenticated, user } = useAuth();

	let [featureFlags, setFeatureFlags] = useState(JSON.parse(localStorage.getItem('featureFlags')) || []);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!isAuthenticated()) {
			setLoading(false);
			return;
		}

		getFeatureFlags();
	}, [user]);

	const getFeatureFlags = async () => {
		try {
			setLoading(true);
			const { data } = await axios.get(GET_FEATURE_FLAG);
			const featureFlagsArr = data.filter((item) => item.active).map((item) => item.feature);
			setFeatureFlags(featureFlagsArr);
			localStorage.setItem('featureFlags', JSON.stringify(featureFlagsArr));
		} catch (e) {
			console.log('error while trying to get featureFlags', { e });
		} finally {
			setLoading(false);
		}
	};

	const value = {
		featureFlags,
		useFeatureFlag,
		matchingEnabled: isMatchingEnabled(featureFlags),
		vacanciesEnabled: isVacanciesEnabled(featureFlags),
		userManagementEnabled: isUserManagementEnabled(featureFlags),
		teamManagementEnabled: isTeamManagementEnabled(featureFlags),
		websiteManagementEnabled: isWebsiteManagementEnabled(featureFlags),
		subscriptionEnabled: isFeatureEnabled(featureFlags, featureFlagsList.subscription),
		subscriptionTokenEnabled: isFeatureEnabled(featureFlags, featureFlagsList.subscriptionToken),
		termsAgreementEnabled: isFeatureEnabled(featureFlags, featureFlagsList.termsAgreement),
		loading,
	};

	return <FeatureFlagContext.Provider value={value}>{children}</FeatureFlagContext.Provider>;
}

const useFeatureFlag = () => useContext(FeatureFlagContext);

export { useFeatureFlag, FeatureFlagProvider };
